module.exports = require("core-js/library/fn/number/is-nan");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/number/is-nan.js
// module id = 338
// module chunks = 0